import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../assets/css/login/login.module.css';

const BtnLogin = ({ children, action, type }) => {
    return (
        <div className={styles.login__button_container}>
            {type === 'submit' ? (
                <button
                    type="submit"
                    // onClick={action}
                    className={styles.login__button}>
                    {children}
                </button>
            ) : (
                <button onClick={action} className={styles.login__button}>
                    {children}
                </button>
            )}
        </div>
    );
};

BtnLogin.propTypes = {
    action: PropTypes.func,
    children: PropTypes.node.isRequired,
    type: PropTypes.string
};

export default BtnLogin;
